import { policyList } from "@/enums/permissions";
import { HttpQuery } from "@/interfaces/httpQuery";
import { Role } from "@/interfaces/roles";
import { EventBus, store } from "@/internal";
import { API_URIS } from "@/utils/constants";
import { TableAction, TableSuccessModalResponse } from "helix-vue-components";
import Http2Service from "./http2.service";

export class PermissionRoleService extends Http2Service {
  constructor() {
    super();
  }

  /**
   * Retrieves the list of users.
   * @param query?: HttpQuery
   * @returns Promise<User[]>
   */
  public async getRoles(query?: HttpQuery): Promise<Role[]> {
    const response = await this.get(API_URIS.PERMISSION_ROLE, query);
    return response.data.data;
  }

  /**
   * Returns the configuration por actionson top of the table.
   */

  public generalActions() {
    return [
      {
        icon: "add",
        class: "buttonClass_5",
        id: "btn_create_role",
        visibleCondition: () =>
          store.getters["authModule/hasPermission"](
            policyList.createPermissionProfile
          ),
        action: (...arg: any[]) => {
          EventBus.$emit("route", {
            name: "permission-management-add",
            currentModel: arg[0]
          });
        },
        componentName: "TableButtonComponent"
      },
      {
        icon: "fal fa-search",
        class: "buttonClass_5",
        id: "btn_search_role",
        componentName: "TableButtonComponent",
        otherComponent: {
          name: "TableSearchComponent"
        }
      }
    ];
  }

  public rowActions(execute: Function): TableAction[] {
    return [
      {
        icon: "fal fa-pen",
        class: "table__actions",
        id: "btn_edit_role",
        visibleCondition: () =>
          store.getters["authModule/hasPermission"](
            policyList.modifyPermissionProfile
          ),
        action: (arg: any) => {
          const payload = {
            name: "permission-management-edit",
            params: {
              id: arg.id
            }
          };
          EventBus.$emit("route", payload);
        }
      },
      {
        icon: "fal fa-trash-alt",
        class: "table__actions",
        id: "btn_delete_role",
        visibleCondition: () =>
          store.getters["authModule/hasPermission"](
            policyList.deletePermissionProfile
          ),
        modalActions: {
          modalNumber: 1,
          modalQuestion: "Are you sure you want to delete this role?",
          modalSuccessText: "yes",
          modalIdSuccess: "btn_delete_yes",
          modalSuccessAction: async (
            response: TableSuccessModalResponse & { item: any }
          ) => {
            this.delete(API_URIS.PERMISSION_ROLE, response.item)
              .then(() => response.unselectModal())
              .finally(() => execute());
          },
          modalCancelText: "No",
          modalIdCancel: "btn_delete_no",
          modalButtonsClass: "buttonClass_5"
        },
        otherComponent: {
          name: "TableModalComponent"
        }
      }
    ];
  }
}

export const PERMISSION_ROLE_SERVICE = new PermissionRoleService();
